import { useQuery } from "@tanstack/react-query";
import { getMemberLocationStats } from "apis/branch/member_location_api";
import { memberLocationKeys } from "apis/branch/query_keys_branch";
import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 회원 위치 통계 가져오기
export const useMemberLocationStats = (queryData, enabled, setEnabled) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: memberLocationKeys.stats(queryData),
    queryFn: () => getMemberLocationStats(queryData),
    enabled: enabled,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setEnabled(false);
    },
  });
};
